import { createTheme } from "@mui/material/styles";

export const colors = {
  preussiskBla: "#003959",
  solbaer: "#1B1528",
  orange: "#F58326",
  safran: "#F6BB26",
  snostorm: "#A4D9EA",
  viking: "#5DB9DE",
  red: "#d32f2f",
};

declare module "@mui/material/styles" {
  interface Palette {
    custom: {
      preussiskBla: string;
      solbaer: string;
      orange: string;
      safran: string;
      snostorm: string;
      viking: string;
      red: string;
    };
  }
  interface PaletteOptions {
    custom?: {
      preussiskBla?: string;
      solbaer?: string;
      orange?: string;
      safran?: string;
      snostorm?: string;
      viking?: string;
      red?: string;
    };
  }
}

// LIGHT THEME
export const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: colors.preussiskBla,
      light: colors.viking,
      dark: "#002235",
      contrastText: "#ffffff",
    },
    secondary: {
      main: colors.solbaer,
      contrastText: "#ffffff",
    },
    background: {
      default: "#f5f5f5",
      paper: "#ffffff",
    },
    text: {
      primary: "#1b1528",
      secondary: "#4b4b4b",
    },
    info: {
      main: colors.snostorm,
      contrastText: colors.preussiskBla,
    },
    warning: {
      main: colors.safran,
      contrastText: colors.solbaer,
    },
    error: {
      main: colors.red,
    },
    custom: {
      preussiskBla: colors.preussiskBla,
      solbaer: colors.solbaer,
      orange: colors.orange,
      safran: colors.safran,
      snostorm: colors.snostorm,
      viking: colors.viking,
      red: colors.red,
    },
  },
  typography: {
    fontFamily: `"Inter", "Roboto", "Helvetica", "Arial", sans-serif`,
  },
});

// DARK THEME
export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: colors.viking, // brighter blue for dark background
      light: colors.snostorm,
      dark: colors.preussiskBla,
      contrastText: "#ffffff",
    },
    secondary: {
      main: colors.solbaer,
      contrastText: "#ffffff",
    },
    background: {
      default: "#111118",
      paper: "#1a1a20",
    },
    text: {
      primary: "#ffffff",
      secondary: "#c2c2c2",
    },
    info: {
      main: colors.snostorm,
      contrastText: colors.preussiskBla,
    },
    warning: {
      main: colors.safran,
      contrastText: colors.solbaer,
    },
    error: {
      main: colors.red,
    },
    custom: {
      preussiskBla: colors.preussiskBla,
      solbaer: colors.solbaer,
      orange: colors.orange,
      safran: colors.safran,
      snostorm: colors.snostorm,
      viking: colors.viking,
      red: colors.red,
    },
  },
  typography: {
    fontFamily: `"Inter", "Roboto", "Helvetica", "Arial", sans-serif`,
  },
});
